import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type BulkFormPasteSlotProps = Omit<
  ComponentProps<"input">,
  "onChange" | "value" | "defaultValue" | "type" | "children" | "onPaste"
> & {
  onPaste(text: string): void
}

// Visually hidden text input that lets non-text widgets (selects, custom
// pickers) participate in the bulk-form generic paste protocol. The bulk
// form's paste handler walks the row's `<td>`s and dispatches a synthetic
// `input` event on each cell's first `<input>`. Drop one of these next to a
// non-input widget and translate the pasted text into the widget's value.
function BulkFormPasteSlot(props: BulkFormPasteSlotProps) {
  const { onPaste, className, ...inputProps } = props

  return (
    <input
      type="text"
      aria-hidden
      tabIndex={-1}
      defaultValue=""
      className={cn("bulk-form-paste-slot", className)}
      onChange={(e) => {
        const text = e.currentTarget.value
        if (text.length === 0) return
        onPaste(text)
        // Reset so a follow-up paste of the same text still triggers onChange.
        e.currentTarget.value = ""
      }}
      {...inputProps}
    />
  )
}

export default BulkFormPasteSlot
